import { motion } from "framer-motion";
import { FiGlobe, FiLayers, FiMessageSquare, FiUsers } from "react-icons/fi";
import { stats } from "../../data/fakeData";

const StatsSection = () => {
  const items = [
    {
      icon: FiGlobe,
      value: stats.totalWebsites.toLocaleString() + "+",
      label: "Websites Listed",
      color: "bg-indigo-50 text-indigo-600",
    },
    {
      icon: FiLayers,
      value: stats.totalCategories,
      label: "Categories",
      color: "bg-violet-50 text-violet-600",
    },
    {
      icon: FiMessageSquare,
      value: stats.totalReviews.toLocaleString() + "+",
      label: "User Reviews",
      color: "bg-emerald-50 text-emerald-600",
    },
    {
      icon: FiUsers,
      value: stats.totalUsers.toLocaleString() + "+",
      label: "Community Members",
      color: "bg-amber-50 text-amber-600",
    },
  ];

  return (
    <section className="container-main py-8">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.5 }}
        className="card shadow-xl shadow-slate-200/60 p-1"
      >
        <div className="grid grid-cols-2 lg:grid-cols-4 divide-x divide-y lg:divide-y-0 divide-slate-100">
          {items.map((stat, i) => (
            <motion.div
              key={stat.label}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.08 }}
              className="flex items-center gap-4 p-6 lg:p-8"
            >
              <div
                className={`w-12 h-12 rounded-xl ${stat.color} flex items-center justify-center flex-shrink-0`}
              >
                <stat.icon size={22} />
              </div>
              <div>
                <p className="text-2xl sm:text-3xl font-extrabold text-slate-900 font-display leading-none">
                  {stat.value}
                </p>
                <p className="text-xs font-semibold text-slate-500 mt-1.5">
                  {stat.label}
                </p>
              </div>
            </motion.div>
          ))}
        </div>
      </motion.div>
    </section>
  );
};

export default StatsSection;
